import { useEffect, useState } from "react";
import LoginOtp from "./LoginOtp";

export default function LoginOtpPopup() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Open OTP popup
    const openLoginOtp = () => {
      setShow(true);
    };

    // Close OTP popup
    const closeLoginOtp = () => {
      setShow(false);
    };

    window.addEventListener(
      "open-login-otp",
      openLoginOtp
    );

    window.addEventListener(
      "close-login-otp",
      closeLoginOtp
    );

    return () => {
      window.removeEventListener(
        "open-login-otp",
        openLoginOtp
      );

      window.removeEventListener(
        "close-login-otp",
        closeLoginOtp
      );
    };
  }, []);

  if (!show) {
    return null;
  }

  return (
    <LoginOtp
      onClose={() => setShow(false)}
    />
  );
}